import { graphql, ResultOf } from "@/graphql";

export const CompanyPlanQuery = graphql(`
  query getCompany {
    company {
      id
      subscription {
        planPriceId
        status
        plan {
          name
          billingInterval
          tier {
            id
            level
          }
        }
        tier {
          id
          name
          level
          features {
            hasWaitlist
            hasProTimer
            hasUpsells
            hasRouteOptimization
          }
        }
        pendingTier {
          id
          name
        }
      }
    }
  }
`);

export type CompanyPlan = ResultOf<typeof CompanyPlanQuery>["company"];
